import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip } from "react-tooltip";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

import "../styles/resultrow.css";
import {
  ViewProp,
  ViewType,
} from "../../../interfaces/internal/ViewProps";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import ResultTable from "./ResultTable";
import { ClassesDTO } from "../../../interfaces/ClassesDTO";
import { TimingPositionsDTO } from "../../../interfaces/TimingPositionsDTO";
import ResultStage from "./ResultStage";
import useDebounce from "../../../services/useDebounce";
import Bios from "../../bio/Bios";
import Shootings from "../../shooting/Shootings";
import { useBlade } from "../../../services/BladeProvider";
import Team from "../../teaminfo/Team";
import ResultMap from "../maps/ResultMap";
import SepakerView from "../speakerview/SepakerView";
import { TimeDTO } from "../../../interfaces/TimeDTO";

interface Props {
  id: number;
  vType: ViewType;
  vwindoprop: ViewProp;
  race: RaceDTO;
  onClose: (id: number) => void | null;
  timeScroll: { [key: number]: TimeDTO } | null;
}
interface TimePOSProp {
  ipos: number;
  name: string;
  timepos?: TimingPositionsDTO | null;
}

function GetClassName(vType: ViewType): string {
  if (vType === ViewType.stage) {
    return " result-blade-stage ";
  }
  else if (vType === ViewType.athletebio || vType === ViewType.athletebioTV) {
    return " result-blade-bio ";
  }
  else if (vType === ViewType.coursemap) {
    return " result-blade-map ";
  }

  return "";
}

const ResultBlade = ({ id, vType, vwindoprop, race, onClose, timeScroll }: Props) => {

  let content = null;
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [forceUpdate, setForceUpdate] = useState<number>(1);

  const [classid, setClassid] = useState<number | null>(vwindoprop.classId);
  const [ipos, setIpos] = useState<number | null>(vwindoprop.ipos);
  const [hideMenu, setHideMenu] = useState<boolean>(false);
  const [level, setLevel] = useState<number | null>(vwindoprop.level);
  const [minimized, setMinimized] = useState<string | null>(null);
  const [shrinkHeight, setShrinkHeight] = useState<number>(1);
  const [selectedClass, setSelectedClass] = useState<ClassesDTO | null>(null);
  const [selectedIntermediate, setSelectedIntermediate] = useState<TimePOSProp | null>(null);
  const [hideClass, setHideClass] = useState<boolean>(true);
  const [hideIpos, setHideIpos] = useState<boolean>(true);
  const [autoChangeIpos, setAutoChangeIpos] = useState<boolean>(false);

  const {
    blades,
    moveBlade,
    heightBlade,
    getHeightBlade,
    getBlade,
    bladeVisuals,
    registerRef,
    organizeBlades,
    setClassIDIpos,
    maximizeBlade,
    getMaximizeBlade,
    getNameBlade,
    setNameBlade,
    getFocusedBlade,
    getMobileMode,
    setAutoIposBlade,
    getAutoIposBlade,
    setHideHamburger,
    getHideHamburger

  } = useBlade();
  const bladeRef = useRef<HTMLDivElement>(null);

  const refSelectedIpos = useRef<number | null>(ipos);
  const refAutoChangeClass = useRef<boolean>(false);

  const ordering = blades.some((o) => o.id == id) ? getBlade(id)?.order : null;

  useEffect(() => {
    if (classid !== null) {
      setSelectedClass(race.Class[classid]);
    }
    if (vType === ViewType.stage) {
      setHideIpos(false);
      setHideClass(true);
    } else if (vType === ViewType.shooting) {
      setHideIpos(false);
      setHideClass(false);
      setHideMenu(true);
    } else if (vType === ViewType.athletebio) {
      setHideIpos(false);
      setHideMenu(true);
      setHideClass(false);
    }
    else if (vType === ViewType.teamdata) {
      setHideIpos(false);
      setHideClass(false);
      setHideMenu(true);
    }
    else if (vType === ViewType.speakerView) {
      setHideIpos(false);
      setHideMenu(true);
      setHideClass(false);
    }
  }, []);

  useEffect(() => {
    if (bladeRef.current) {
      registerRef(id, bladeRef.current);
    }
  }, [id, bladeRef.current]);

  useEffect(() => {
    if (selectedClass === null) {
      return;
    }

    if (ipos == null) {
      onClickIpos(0);
    } else if (ipos == 0) {
      onClickIpos(0);
    } else {
      let imt = selectedClass?.Level[level!].TimePos[ipos];
      if (imt) {
        onClickIpos(ipos);
      } else if (ipos == -999) {
        onClickIpos(-999);
      } else {
        onClickIpos(999);
      }
    }
    getHeaderText();
  }, [selectedClass]);

  useEffect(() => {
    organizeBlades();
  }, [minimized]);

  useEffect(() => {
    getHeaderText();
  }, [selectedIntermediate]);
  useEffect(() => {
    setAutoIposBlade(id,autoChangeIpos);
  }, [autoChangeIpos]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
  
    if (autoChangeIpos) {
      interval = setInterval(() => {
        if (!selectedClass || !level) {
          return;
        }
        
        const tposes = race.Class[selectedClass.ID].Level[level].TimePos;
        const keys = Object.keys(tposes)
          .filter(o => parseInt(o) < 1000)
          .sort((a, b) => parseInt(b) - parseInt(a));
          
        
        const newIpos = keys.find((key) => {
          const res = tposes[parseInt(key)].TimePass.filter(o => o.RunTimeMS < 86300000);
          return res.length > 0;
        });
  
        // console.log(newIpos);
        // console.log(refSelectedIpos.current)
        if (newIpos !== undefined && parseInt(newIpos) !== refSelectedIpos.current) {
          // setIpos(parseInt(newIpos));
          onChangeIpos(parseInt(newIpos),`Auto (${tposes[parseInt(newIpos)].Name})`);
        }
      }, 1000);
    }
  
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [autoChangeIpos, selectedClass, level, ipos, race.Class]);
  
  useEffect(() => {
    refSelectedIpos.current = ipos;
  },[ipos])

  const onClickMinimize = () => {
    maximizeBlade(vwindoprop.id, null);
  };

  const getHeaderText = () => {
    let headText = "";
    let ClassName = "";

    if (selectedClass) {
      ClassName = ", " + selectedClass.Name;
    }

    if (vType === ViewType.resultPretime || vType === ViewType.result || vType === ViewType.scroll) {
      headText = (vType === ViewType.scroll ? "(SC) " : "") + (selectedIntermediate ? selectedIntermediate.name : "") + ClassName;
      if (headText === "") {
        headText = "Result/Startlist";
      }
    } else if (vType === ViewType.stage) {
      headText = "Sprint" + (ClassName);
    } else if (vType === ViewType.athletebio) {
      headText = "Athlete bio";
    } else if (vType === ViewType.teamdata) {
      headText = "Team results";
    } else if (vType === ViewType.athletebioTV) {
      headText = "Athlete bio auto follow";
    } else if (vType === ViewType.shooting) {
      headText = "Shooting range";
    } else if (vType === ViewType.resultAnalytics) {
      headText = "Analytics";
    } else if (vType === ViewType.coursemap) {
      headText = "BETA map";
    } else if (vType === ViewType.speakerView) {
      headText = "BETA speakermode";
    }
    setNameBlade(vwindoprop.id, headText);
  }

  const onClickClass = (classid: number) => {
    setSelectedClass(race.Class[classid]);
    setClassIDIpos(id, classid, null);
  };

  const onClickIpos = (ipos: number) => {
    if (vType == ViewType.stage) {
      return;
    }
    let imt = selectedClass?.Level[level!].TimePos[ipos];

    let posName = "";
    if (ipos == 0) {
      posName = "Startlist";
      setAutoChangeIpos(false);
    } else if (ipos == -1) {
      posName = "Auto";
      setAutoChangeIpos(true);
      setIpos(-1);
      return;
    } else if (imt) {
      posName = imt.Name;
      setAutoChangeIpos(false);
    }
    onChangeIpos(ipos,posName);
  };
  const onChangeIpos = (ipos:number,posName:string) => {
    let imt = selectedClass?.Level[level!].TimePos[ipos];

    let tpo: TimePOSProp = {
      ipos: ipos,
      name: posName,
      timepos: imt,
    };
    setSelectedIntermediate(tpo);
    if (selectedClass?.ID !== undefined) {
      setClassid(selectedClass === null ? null : selectedClass.ID);
      setIpos(ipos);
      setClassIDIpos(id, selectedClass!.ID, ipos);
    }
    setForceUpdate((act) => act + 1);
  }

  if (vType == ViewType.stage) {
    content = (
      <ResultStage
        vwindPropId={vwindoprop.id}
        race={race}
        classid={selectedClass == null ? null : selectedClass.ID}
      />
    );
  } else if (vType == ViewType.athletebio || vType === ViewType.athletebioTV) {
    content = <Bios race={race} vType={vType} />;
  } else if (vType == ViewType.shooting) {
    content = <Shootings race={race} />;
  } else if (vType == ViewType.teamdata) {
    content = <Team race={race} />;
  } else if (vType == ViewType.speakerView) {
    content = <SepakerView
      key={forceUpdate}
      classid={classid}
      level={level}
      Tpos={selectedIntermediate === null ? null : selectedIntermediate.timepos!}
      Ipos={ipos === 0 ? ipos : null}
      race={race}
      vType={vType}
      vwindPropId={vwindoprop.id}
      timeScroll={timeScroll}
    ></SepakerView>;
  } else if (vType === ViewType.coursemap) {
    content = <ResultMap race={race} />
  } else if (classid !== null && ipos !== null) {
    content = (
      <ResultTable
        key={forceUpdate}
        classid={classid}
        level={level}
        Tpos={selectedIntermediate === null ? null : selectedIntermediate.timepos!}
        Ipos={ipos === 0 ? ipos : null}
        race={race}
        vType={vType}
        vwindPropId={vwindoprop.id}
      ></ResultTable>
    );
  } else {
    content = (
      <ResultTable
        key={forceUpdate}
        classid={null}
        level={level}
        Tpos={null}
        Ipos={null}
        race={race}
        vType={vType}
        vwindPropId={vwindoprop.id}
      ></ResultTable>
    );
  }

  const bladObj = getBlade(id);
  const mergedStyles = {
    height: bladObj !== null ? bladObj.heightprocent : "100",
    order: ordering === null ? undefined : ordering,
    display: getFocusedBlade(id) || !getMobileMode() ? "block" : "none",
    ...bladeVisuals[id], // Spread the styles from BladeVisuals[id] into the mergedStyles object
  };

  return (
    <div
      className={
        "result-blade " +
        GetClassName(vType) +
        (getMaximizeBlade(vwindoprop.id) ? "" : " result-small ") +
        (getHeightBlade(vwindoprop.id) ? "" : " result-blade-half-height ") +
        (hideIpos ? "" : " result-blade-hide-ipos") +
        (hideClass ? "" : " result-blade-hide-class") +
        (hideMenu || getHideHamburger(vwindoprop.id) ? " result-blade-hide-menu" : "")
      }
      id={id.toString()}
      ref={bladeRef}
      style={mergedStyles}
    >
      <div className="result-blade-menu">
        <div className="result-blade-menu-box">
          <div
            className="result-blade-hamburger"
            style={{ transform: getHideHamburger(vwindoprop.id) ? "rotate(0deg)" : "rotate(180deg)" }}
            onClick={() => setHideHamburger(vwindoprop.id)}
          >
            <div className="result-blade-hamburger-button result-blade-hamburger-top">&nbsp;</div>
            <div className="result-blade-hamburger-button result-blade-hamburger-middle">&nbsp;</div>
            <div className="result-blade-hamburger-button result-blade-hamburger-bottom">&nbsp;</div>
          </div>
          <button
            className="result-blade-menu-button result-blade-menu-left"
            data-handle="move-left"
            data-view-owner="0"
            onClick={() => moveBlade(id, true)}
          >
            &nbsp;
          </button>
          <button
            className="result-blade-menu-button result-blade-menu-right"
            data-handle="move-right"
            data-view-owner="0"
            onClick={() => moveBlade(id, false)}
          >
            &nbsp;
          </button>
          <span className="result-blade-menu-header-text">{getMobileMode() ? race.Name : getNameBlade(vwindoprop.id)}</span>
          <button
            className="result-blade-menu-button result-blade-menu-color"
            data-handle="change-color"
            data-view-owner="0"
          >
            &nbsp;
          </button>
          <button
            className="result-blade-menu-button result-blade-menu-minimize"
            data-handle="minimize"
            data-view-owner="0"
            onClick={() => onClickMinimize()}
          >
            &nbsp;
          </button>
          <button
            className="result-blade-menu-button result-blade-menu-height"
            data-handle="height"
            data-view-owner="0"
            onClick={() => heightBlade(id, null)}
          >
            &nbsp;
          </button>
          <button
            className="result-blade-menu-button result-blade-menu-close"
            data-handle="close"
            data-view-owner="0"
            onClick={() => onClose(id)}
          >
            &nbsp;
          </button>
        </div>
        <div className="result-blade-menu-box">
          <div className="result-blade-menu-choose result-blade-menu-class">
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className="btn-sm result-blade-menu-dropdown"
              >
                {selectedClass == null ? "Choose class" : selectedClass.Name}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                {race?.Class &&
                  Object.keys(race?.Class).map((key) => (
                    <Dropdown.Item
                      key={key}
                      onClick={() => onClickClass(parseInt(key))}
                    >
                      {race?.Class[parseInt(key)].Name}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="result-blade-menu-choose result-blade-menu-timingpoint">
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className="btn-sm result-blade-menu-dropdown"
              >
                {selectedIntermediate == null ? "Choose timing" : selectedIntermediate.name}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Dropdown.Item onClick={() => onClickIpos(0)}>Startlist</Dropdown.Item>
                <Dropdown.Item onClick={() => onClickIpos(-1)}>Auto</Dropdown.Item>
                <Dropdown.Divider />
                {selectedClass &&
                  Object.keys(selectedClass.Level[level!].TimePos).map((key) => {
                    if ((parseInt(key) > 999 && (vType !== ViewType.resultAnalytics)) || (vType === ViewType.resultAnalytics && parseInt(key) < 1000)) {
                      return true;
                    }
                    return (
                      <Dropdown.Item
                        key={key}
                        onClick={() => onClickIpos(parseInt(key))}
                      >
                        {selectedClass.Level[level!].TimePos[parseInt(key)].Name}
                      </Dropdown.Item>
                    )
                  })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="result-blade-menu-colorpicker">
          <div className="result-blade-menu-color-pick color-blue">&nbsp;</div>
          <div className="result-blade-menu-color-pick color-red">&nbsp;</div>
          <div className="result-blade-menu-color-pick color-black">&nbsp;</div>
          <div className="result-blade-menu-color-pick color-orange">&nbsp;</div>
          <div className="result-blade-menu-color-pick color-pink">&nbsp;</div>
          <div className="result-blade-menu-color-pick color-green">&nbsp;</div>
        </div>
      </div>
      <div className="result-blade-view-data">{content}</div>
    </div>
  );
};
export default ResultBlade;
